import React, { useState, useEffect } from 'react';

import { User } from '../../../services/Services';
import { ProductCommunicator } from '../../../Communicators/ProductCommunicator';
import { HighlightedProducts } from './HighlightedProducts';
import { HighlightedProduct } from './HighlightedProduct';

import './Highlights.scss';

const logged = User.loggedIn();

export const Highlights = () => {
  const [specials, setSpecials] = useState(null);
  const [onSale, setOnSale] = useState(null);

  const fetchSpecials = async () => {
    const spec = await ProductCommunicator.getSpecialOffer();
    setSpecials(spec);
  };

  const fetchOnSale = async () => {
    const sale = await ProductCommunicator.getOnSale();
    setOnSale(sale);
  };

  useEffect(() => {
    fetchSpecials();
    fetchOnSale();
  }, []);

  return (
    <div className="highlights">
      <HighlightedProducts products={specials} logged={logged} />
      <HighlightedProducts products={onSale} logged={logged} title="Na Akciji" />
      {/* <div className="single-highlighted">
        <div className="section-header">
          <span className="section-header-line" />
          <span className="section-header-text">Ponuda dana</span>
          <span className="section-header-line" />
        </div>
        <HighlightedProduct customClass="highlight-one" products={specials} logged={logged} />
        <HighlightedProduct customClass="highlight-two" products={specials} logged={logged} />
      </div> */}
    </div>
  );
};
